/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * 
 * @export
 * @interface SearchResultPrtimesMediaOutlet
 */
export interface SearchResultPrtimesMediaOutlet {
    /**
     * メディアID
     * @type {number}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaOutletId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    companyName: string;
    /**
     * メディア名
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaName: string;
    /**
     * メディア名のよみがな
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaNameYomigana: string;
    /**
     * メディアのURL
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaUrl: string;
    /**
     * メディアの概要
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    summary: string;
    /**
     * 部署名
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    department: string;
    /**
     * メディア種類ID
     * @type {number}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaTypeId: number;
    /**
     * メディア種類名
     * @type {string}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaTypeName: string;
    /**
     * 
     * @type {MediaReach}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    reach: MediaReach;
    /**
     * 配信方法のリスト
     * @type {Array<string>}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    deliveryMethods: Array<SearchResultPrtimesMediaOutletDeliveryMethodsEnum>;
    /**
     * Newアイコンを表示するかどうか
     * @type {boolean}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    isNew: boolean;
    /**
     * 検索フィルターで指定された業種の親カテゴリ名のリスト
     * @type {Array<string>}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaIndustryGroupNames: Array<string>;
    /**
     * 検索フィルターで指定されたエリアのリスト
     * @type {Array<string>}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaRegionJpNames: Array<string>;
    /**
     * 検索フィルターで指定されたメディア種別のリスト
     * @type {Array<string>}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    mediaTypeNames: Array<string>;
    /**
     * 検索フィルターで指定された都道府県のリスト
     * @type {Array<string>}
     * @memberof SearchResultPrtimesMediaOutlet
     */
    prefectureNames: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum SearchResultPrtimesMediaOutletDeliveryMethodsEnum {
    Email = 'email',
    Fax = 'fax'
}

export function SearchResultPrtimesMediaOutletFromJSON(json: any): SearchResultPrtimesMediaOutlet {
    return SearchResultPrtimesMediaOutletFromJSONTyped(json, false);
}

export function SearchResultPrtimesMediaOutletFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultPrtimesMediaOutlet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaOutletId': json['media_outlet_id'],
        'companyName': json['company_name'],
        'mediaName': json['media_name'],
        'mediaNameYomigana': json['media_name_yomigana'],
        'mediaUrl': json['media_url'],
        'summary': json['summary'],
        'department': json['department'],
        'mediaTypeId': json['media_type_id'],
        'mediaTypeName': json['media_type_name'],
        'reach': MediaReachFromJSON(json['reach']),
        'deliveryMethods': json['delivery_methods'],
        'isNew': json['is_new'],
        'mediaIndustryGroupNames': json['media_industry_group_names'],
        'mediaRegionJpNames': json['media_region_jp_names'],
        'mediaTypeNames': json['media_type_names'],
        'prefectureNames': json['prefecture_names'],
    };
}

export function SearchResultPrtimesMediaOutletToJSON(value?: SearchResultPrtimesMediaOutlet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_outlet_id': value.mediaOutletId,
        'company_name': value.companyName,
        'media_name': value.mediaName,
        'media_name_yomigana': value.mediaNameYomigana,
        'media_url': value.mediaUrl,
        'summary': value.summary,
        'department': value.department,
        'media_type_id': value.mediaTypeId,
        'media_type_name': value.mediaTypeName,
        'reach': MediaReachToJSON(value.reach),
        'delivery_methods': value.deliveryMethods,
        'is_new': value.isNew,
        'media_industry_group_names': value.mediaIndustryGroupNames,
        'media_region_jp_names': value.mediaRegionJpNames,
        'media_type_names': value.mediaTypeNames,
        'prefecture_names': value.prefectureNames,
    };
}

